<template>
  <div class="amidan_wrap">
    <div class="amidan">
      <page-header class="not_main"></page-header>
      <div class="amidan_content">
        <image-component :infoType="`fsBanner`"></image-component>

        <div class="amidan_tab_wrap">
          <div class="tab">
            <div class="tab_content" :class="{'active': tab=='introduce'}" @click="changeTab('introduce')">아미단소개</div>
            <div class="tab_content" :class="{'active': tab=='mentor'}" @click="changeTab('mentor')">멘토소개</div>
            <div class="tab_content" :class="{'active': tab=='join'}" @click="changeTab('join')">가입신청</div>
          </div>
        </div>
        <!-- 아미단 소개 이미지 컴포넌트(AmidanIntroducelayout) 들어갈 자리-->
        <div class="introduce_content" v-if="tab === 'introduce'">
          <img class="introduce_content_img" src="@/assets/image/img_2.png">
        </div>


        <div class="mentor_content" v-if="tab === 'mentor'">
          <member-list-component v-if="tab === 'mentor'" :memberType="'member'"></member-list-component>
        </div>

        <regist-component v-if="tab === 'join'"></regist-component>


      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import ImageComponent from "@/components/information/ImageComponent";
import MemberListComponent from "@/components/member/MemberListComponent";
import RegistComponent from "@/components/member/RegistComponent";

export default {
  name: "Amidan",
  mixins: [],
  components: {
    RegistComponent,
    ImageComponent,
    MemberListComponent
  },
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      tab: 'introduce',

      value: '',

      input_name: '',
      input_job: '',
      input_birthday: '',
      input_phone: '',
      input_email: '',

      district_2: [{
        value: '서울',
        label: '서울'
      }, {
        value: '부산',
        label: '부산'
      }],

      district_3: [{
        value: '서울',
        label: '서울'
      }, {
        value: '부산',
        label: '부산'
      }],

      introduce_textarea: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.tab = this.$route.query.tab;
    if (util.isEmpty(this.tab)) {
      this.changeTab('vision');
    }
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    changeTab(val) {
      this.tab = ''
      this.$nextTick(() => {
        this.tab = val;
      })
      this.$router.replace(`${this.$route.path}?tab=${val}`);
    }
  },
  watch: {
    "$route.fullPath": {
      deep: true,
      handler: function (val, oldVal) {
        console.log('tab = ', this.tab)
        console.log('route tab = ', this.$route.query.tab)
        if (this.tab != this.$route.query.tab) {
          this.changeTab(this.$route.query.tab);
        }
      }
    }
  },
}
</script>

<style scoped>

</style>